import React from 'react';
import {
	Button,
	Checkbox,
	Dropdown,
	Grid,
	GridColumn,
	Header,
	Label,
	Pagination,
	Segment,
	Table
} from 'semantic-ui-react';
import { inject, observer } from 'mobx-react';
import type { DashboardScript } from 'stores/ui/manager/Dashboard';
import { withRouter } from 'react-router-dom';
import styles from './styles';
import { observable } from 'mobx';
import MsgStore from 'stores/MsgStore';
import MessageBox from 'components/MessageBox';
import type { ScriptCounts } from 'types/common';
import SortByField from 'components/SortByField';
import UiShared from 'stores/UiShared';
import PrescribersScreen from 'stores/ui/admin/Prescribers';
import Prescriber from 'stores/Prescriber';

@withRouter
@inject(rootStore => ({
	prescribersScreen: rootStore.ui.admin.prescribers,
	uiShared: rootStore.uiShared
}))
@observer
export default class PrescribersList extends React.Component {
	props: {
		prescribersScreen: PrescribersScreen,
		uiShared: UiShared
	};

	@observable pageSize: number = 100;
	@observable scriptToDisplayId: number = null;
	@observable selectedUser: Account = null;

	msgStore: MsgStore = new MsgStore();

	componentDidMount() {
		const { prescribersScreen } = this.props;
		try {
			prescribersScreen.loadItems();
		} catch (err) {
			this.msgStore.setError(err);
		}
	}

	render() {
		const { history } = this.props;
		const prescribersScreen: PrescribersScreen = this.props.prescribersScreen;
		const { items } = prescribersScreen;
		const { enabledWip } = this.props.uiShared;
		return (
			<Segment loading={prescribersScreen.isLoading}>
				<Header as="h1">Prescribers</Header>
				<MessageBox msgStore={this.msgStore} />
				<div className={styles.viewSelectorRow}>
					<div>
						{enabledWip && (
							<Button
								icon="add"
								size="small"
								label="Add new prescriber"
								primary
								onClick={() => history.push('/app/admin/prescribers/0')}
								className={styles.btnAdd}
							/>
						)}
					</div>
					<div>
						<Label size="large" basic className={styles.viewLbl}>
							Records per page:
						</Label>
						<Dropdown
							selection
							placeholder="Records per page"
							value={this.pageSize}
							onChange={(e, data) => {
								this.pageSize = data.value;
								prescribersScreen.setPageSize(data.value);
							}}
							compact
							options={[
								{ text: '10', value: 10 },
								{ text: '20', value: 20 },
								{ text: '50', value: 50 },
								{ text: '100', value: 100 }
							]}
						/>
					</div>
				</div>

				<Grid>
					<GridColumn>
						<Table celled>
							<Table.Header>
								<Table.Row>
									<Table.HeaderCell>
										<SortByField
											label="First Name"
											field="prescriberName"
											store={prescribersScreen}
											filterType="like"
											enableFiltering
										/>
									</Table.HeaderCell>
									<Table.HeaderCell>
										<SortByField
											label="Last Name"
											field="prescriberSurname"
											store={prescribersScreen}
											filterType="like"
											enableFiltering
										/>
									</Table.HeaderCell>
									<Table.HeaderCell>Practices</Table.HeaderCell>
									<Table.HeaderCell>
										<SortByField
											label="Prescriber No"
											field="prescriberNo"
											store={prescribersScreen}
											filterType="like"
											enableFiltering
										/>
									</Table.HeaderCell>
									<Table.HeaderCell>
										<SortByField
											label="Type"
											field="prescriberType"
											store={prescribersScreen}
											filterType="like"
											enableFiltering
										/>
									</Table.HeaderCell>
									<Table.HeaderCell>Mobile</Table.HeaderCell>
									<Table.HeaderCell>Email Address</Table.HeaderCell>
									<Table.HeaderCell>Disabled</Table.HeaderCell>
									<Table.HeaderCell>Actions</Table.HeaderCell>
								</Table.Row>
							</Table.Header>

							<Table.Body>
								{items.map((el: Prescriber, idx) => (
									<Table.Row key={idx}>
										<Table.Cell>{el.prescriberName}</Table.Cell>
										<Table.Cell>{el.prescriberSurname}</Table.Cell>
										<Table.Cell>
											{el.PrescriberPractices?.map((pp, i, arr) => {
												return (
													`${pp.Practice.practiceName?.trim()}` + (i === arr.length - 1 ? '' : ', ')
												);
											})}
										</Table.Cell>
										<Table.Cell>{el.prescriberNo}</Table.Cell>
										<Table.Cell>{el.prescriberType}</Table.Cell>
										<Table.Cell>{el.prescriberMobile}</Table.Cell>
										<Table.Cell>{el.prescriberEmail}</Table.Cell>
										<Table.Cell>
											<Checkbox checked={el.disabled} readOnly />
										</Table.Cell>
										<Table.Cell>
											{enabledWip && (
												<Button
													icon="edit"
													size="small"
													label="Edit"
													primary
													onClick={() => history.push(`/app/admin/prescribers/${el.id}`)}
												/>
											)}
										</Table.Cell>
									</Table.Row>
								))}
							</Table.Body>

							<Table.Footer>
								<Table.Row>
									<Table.HeaderCell colSpan="10" textAlign="right">
										{prescribersScreen.numberOfPages > 0 && (
											<Pagination
												activePage={prescribersScreen.pageIndex + 1}
												totalPages={prescribersScreen.numberOfPages}
												onPageChange={(e, { activePage }) =>
													prescribersScreen.setPageIndex(activePage - 1)
												}
											/>
										)}
									</Table.HeaderCell>
								</Table.Row>
							</Table.Footer>
						</Table>
					</GridColumn>
				</Grid>
			</Segment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/routes/Admin/Prescribers/List.js